import { FC } from 'react';
import classNames from 'classnames';

import { Pressable } from '../../../shared/ui';

interface IColorCardsProps {
  colors: string[];
  selected?: string | null;
  onSelect?: (color: string) => void;
}

export const ColorCards: FC<IColorCardsProps> = ({ colors, selected, onSelect }) => {
  return (
    <div className="grid grid-cols-4 gap-3 mt-6">
      {colors.map((color, idx) => (
        <Pressable
          key={idx}
          aria-label={`Цвет ${idx + 1}`}
          aria-pressed={selected === color}
          onClick={() => onSelect?.(color)}
          className={classNames(
            'w-[54.5px] h-[71px] rounded-control transition-all',
            selected === color ? 'border-white scale-105' : 'border-transparent',
          )}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>
  );
};
